import { v4 as uuidv4 } from 'uuid';

const UUID_LOCAL_STORAGE_KEY = 'FFF_gtb_uuid';

const getUUID = () => {
  const uuidFromLocalStorage = localStorage.getItem(UUID_LOCAL_STORAGE_KEY);
  if (!uuidFromLocalStorage) {
    localStorage.setItem(UUID_LOCAL_STORAGE_KEY, uuidv4());
  }
  return localStorage.getItem(UUID_LOCAL_STORAGE_KEY) || '';
};

export { getUUID, UUID_LOCAL_STORAGE_KEY };
